var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUserMinusSolid = function SvgUserMinusSolid(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 10.5H15.5C15.225 10.5 15 10.725 15 11V12C15 12.275 15.225 12.5 15.5 12.5H21.5C21.775 12.5 22 12.275 22 12V11C22 10.725 21.775 10.5 21.5 10.5ZM9 12C11.2094 12 13 10.2094 13 8C13 5.79063 11.2094 4 9 4C6.79063 4 5 5.79063 5 8C5 10.2094 6.79063 12 9 12ZM11.8 13H11.2781C10.5844 13.3188 9.8125 13.5 9 13.5C8.1875 13.5 7.41875 13.3188 6.72188 13H6.2C3.88125 13 2 14.8813 2 17.2V18.5C2 19.3281 2.67188 20 3.5 20H14.5C15.3281 20 16 19.3281 16 18.5V17.2C16 14.8813 14.1187 13 11.8 13Z",
    fill: "black"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUserMinusSolid, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user_minus_solid.79531d66.svg";
export { ForwardRef as ReactComponent };